import { Facebook, Linkedin, Mail, Phone } from "lucide-react";
import { FaXTwitter } from "react-icons/fa6";
import DesktopNavBar from "./desktop-navbar";
import MobileNavMenu from "./mobile-nav-menu";
import NavBarProfileLogin from "./navbar-profile-login";

function Socials() {
  return (
    <div className="flex items-center gap-x-4">
      <a
        href="https://twitter.com/eastcoastscholars"
        className="hover:opacity-80 transition-opacity"
        aria-label="Twitter"
      >
        <FaXTwitter className="w-4 h-4" />
      </a>
      <a
        href="https://www.linkedin.com/company/east-coast-scholars/"
        className="hover:opacity-80 transition-opacity"
        aria-label="LinkedIn"
      >
        <Linkedin className="w-5 h-5" fill="white" strokeWidth={0} />
      </a>
      <a
        href="https://www.facebook.com/eastcoastscholars"
        className="hover:opacity-80 transition-opacity"
        aria-label="Facebook"
      >
        <Facebook className="w-5 h-5" fill="white" strokeWidth={0} />
      </a>
    </div>
  );
}

export default function Header() {
  return (
    <>
      {/* Top Red Contact Bar */}
      <div className="flex h-12 w-full items-center justify-end md:justify-between bg-primary text-white text-xs font-semibold px-4 md:px-6">
        <div className="gap-x-4 hidden md:flex">
          <a
            href="tel:+15166145834"
            className="flex items-center gap-x-2 hover:opacity-80 transition-opacity"
          >
            <span className="sr-only">Phone</span>
            <Phone
              fill={"white"}
              className="w-4 h-4"
              style={{ transform: "scaleX(-1)", color: "var(--primary)" }}
              strokeWidth={1}
            />
            (516) 614-5834
          </a>
          <a
            href="mailto:admissions@eastcoastscholars.com"
            className="flex items-center gap-x-2 hover:opacity-80 transition-opacity"
          >
            <span className="sr-only">Email</span>
            <Mail className="w-4 h-4" />
            admissions@eastcoastscholars.com
          </a>
        </div>

        {/* Social Links and Login */}
        <div className="flex items-center gap-x-3">
          <Socials />
          <div className="border-l border-white h-4 mx-2"></div>
          <NavBarProfileLogin />
        </div>
      </div>

      {/* Main Navigation Bar */}
      <header className="flex h-16 w-full items-center justify-between bg-white shadow-sm px-4 md:px-6">
        <div className="flex items-center">
          <a href="https://www.eastcoastscholars.com">
            <h1 className="text-gray-900 tracking-tight font-[Merriweather] font-bold">
              EAST COAST SCHOLARS
            </h1>
          </a>
        </div>

        <nav className="flex items-center gap-x-6">
          <div className="hidden lg:flex">
            <DesktopNavBar />
          </div>
          <div className="flex lg:hidden">
            <MobileNavMenu />
          </div>

          {/* CTA Button */}
          <a
            href="https://www.eastcoastscholars.com/contact/"
            className="hidden md:flex bg-secondary hover:bg-secondary text-primary px-3 py-2 rounded-md text-xs font-semibold border border-secondary transition-colors duration-200 items-center gap-x-2"
          >
            BOOK A FREE CONSULTATION
            <span className="text-primary">→</span>
          </a>
        </nav>
      </header>
    </>
  );
}
